import styled from 'styled-components';

export const StyledProgressiveDisclosureContainer = styled.div`
  padding-left: ${({ theme }) => theme.spacing.mini};
  border-left: 1.5px solid ${({ theme }) => theme.palette.gray[200]};
  margin-left: ${({ theme }) => theme.spacing.mini};
  margin-top: ${({ theme }) => theme.spacing.micro};
`;
